import { Currency } from '@models';
import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/CURRENCYBOARD') => `${reducer}/${actionType}`;

export const getList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const list = Currency.getList(res?.info?.products ?? []);

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.currencyBoard,
					$info: res.info || null,
					productList: list
						.filter((item) => item?.ISHEAD !== 'N' && item?.SYMBOL !== 'IRR')
						.sort((prev, next) => prev.ORDERNUM - next.ORDERNUM)
						.slice(0, 8),
					visibleProductList: list
						.filter((item) => item?.ISVISIBLE !== 'N')
						.sort((prev, next) => prev.ORDERNUM - next.ORDERNUM),
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.currencyBoard,
					$info: null,
					productList: [],
					visibleProductList: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.currencyBoard,
					_info: status,
				},
			});
		};

		api.$product_fetch_type({ onOK, onFail, onStatus }, { type: 'C', isUpdated: true });
	};
};
